<template>
  <nav-item
    class="search-box"
    :title="$t('navigation.search')"
    icon="search"
    :active="showSearch"
    hover-color="beige"
    @click="showSearch = true"
  />
  <search-dialog v-model:value="showSearch" />
</template>
<script>
import NavItem from '@/components/navigation/NavItem.vue';
import SearchDialog from '@/components/navigation/SearchDialog.vue';
import { EventBus } from '@/lib/event-bus';

export default {
  name: 'SearchBox',
  components: { SearchDialog, NavItem },
  data() {
    return { showSearch: false };
  },
  methods: {
    handleKeyDown(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.stopPropagation();
        event.preventDefault();
        this.showSearch = true;
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown);
    EventBus.$on('show-search', () => {
      this.showSearch = true;
    });
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    EventBus.$off('show-search', () => {
      this.showSearch = true;
    });
  },
};

</script>
